
const ADD_UPDATE_CONTENT_BY_TYPE = "ADMINRoutes/AddContent"; 
const GET_CONTENT_BY_TYPE = "ADMINRoutes/GetContentByTypes"; 


export { ADD_UPDATE_CONTENT_BY_TYPE, GET_CONTENT_BY_TYPE };
  